import { render, staticRenderFns } from "./CardResponsibleUser.vue?vue&type=template&id=1b8f020e&scoped=true&"
import script from "./CardResponsibleUser.vue?vue&type=script&lang=js&"
export * from "./CardResponsibleUser.vue?vue&type=script&lang=js&"
import style0 from "./CardResponsibleUser.vue?vue&type=style&index=0&id=1b8f020e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f020e",
  null
  
)

export default component.exports